<template>
  <ModalBase :show-modal="true" @close-modal="close" short auto-h class="gk-modal-confirm">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ $gettext('Payment Link') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <b-row>
        <b-col cols="4">
          <AnimationItem class="anim-company" :animation="{ animationData: paymentLinkAnimation.default }" :key="'anim_success'" />
        </b-col>
        <b-col>
          <p v-if="status === 'failed'" v-translate>
            There was an error connecting to Mollie. Please try submitting the application form again or contact our support team.
          </p>
          <p v-if="status === 'disconnected'" v-translate>
            Your Mollie account was disconnected. Please try submitting the application form again or contact our support team.
          </p>
          <p v-if="status === 'missing-data'" v-translate>
            You cannot send payment links without a completed Mollie account. Please <span class="emphasize">update the information in your Mollie account</span>. Once you have done this, you can start sending payment links with you invoice.
          </p>
          <div v-if="status === 'no-profile'">
            <p v-translate>Adding a payment link will on average make your customer pay your invoice 3 times faster. Premium users can send payment links for free and will only pay the Mollie fee for successful payments. Basic users pay an aditional 50 cents per successful transaction.</p>
            <p v-translate>You just have to setup a payment account with our partner Mollie. It will only take a couple of minutes.</p>
          </div>
        </b-col>
      </b-row>
    </template>
    <template v-slot:actions>
      <div class="d-flex justify-content-between align-items-center w-100">
        <GekkoButton
          :href="Urls['accounts_ideal_payment_settings']()"
          :text="$gettext('My Mollie settings')"
          variant="link"
          class="px-0"
        />
        <div>
          <GekkoButton
            @click="close()"
            :text="$gettext('Cancel')"
            variant="light"
            class="mr-2"
          />
          <GekkoButton
            v-if="status === 'missing-data'"
            href="https://www.mollie.com/dashboard/onboarding/organization-details"
            :text="$gettext('Update mollie information')"
          />
          <GekkoButton
            v-if="status === 'no-profile'"
            :href="Urls['accounts_ideal_payment_settings']()"
            :text="$gettext('Get started')"
            icon="fa-solid fa-plug"
          />
          <!-- <GekkoButton
            @click="connectToMollie()"
            :text="$gettext('Get started')"
            icon="fa-solid fa-plug"
          /> -->
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import * as paymentLinkAnimation from '@/css/animations/payment-link.json';
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue';

export default {
  name: 'MollieNoProfileModal',
  components: {
    TitleBar,
    GekkoButton,
    ModalBase,
    AnimationItem
  },
  props: {
    status: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      paymentLinkAnimation: paymentLinkAnimation
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    connectToMollie () {
      console.log('connectToMollie')
    }
  },
}
</script>

<style lang="scss" scoped>

</style>